import BookTravel from './BookTravel'
import Cashback from './Cashback'
import GiftCards from './GiftCards'
import History from './History'
import Mortgage from './Mortgage'
import PointsTransfer from './PointsTransfer'
import RewardsOutlined from './RewardsOutlined'

export const RewardsIcons = {
  BookTravel,
  Cashback,
  GiftCards,
  History,
  Mortgage,
  PointsTransfer,
  RewardsOutlined,
}
